import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'dva'

import { MAP_MODES } from '../../lib/constants'
import BasemapSelector from '../MapView/BasemapSelector'
import Compass from '../MapView/GHCompass'
import Coordinates from '../MapView/Coordinates'
import CrosshairWidget from '../MapView/CrosshairWidget'
import ElevationProfileWidget from '../MapView/ElevationProfileWidget'
import GHScaleBar from '../MapView/GHScaleBar'
import GHWidgetBar from '../MapView/GHWidgetBar'
import MapToast from '../MapView/MapToast'
import MapZoomCtrl from '../MapView/MapZoomCtrl'
import MeasurementWidget from '../MapView/MeasurementWidget'
import NavigationToggle from '../MapView/NavigationToggle'
import Search from '../MapView/Search'
import SelectWidget from '../MapView/SelectWidget'
import SketchWidget from '../MapView/SketchWidget'
import TwoDThreeDToggle from '../MapView/TwoDThreeDToggle'
import styles from './WidgetPanel.module.scss'

function WidgetPanel(props) {
  return (
    <div id='widget-panel' className={styles.widgetContainer}>
      <BasemapSelector />
      <Compass view={props.viewRef} map={props.mapRef} />
      <Coordinates view={props.viewRef} map={props.mapRef} />
      <CrosshairWidget />
      <GHScaleBar view={props.viewRef} map={props.mapRef} />
      <GHWidgetBar view={props.viewRef} map={props.mapRef}>
        <SelectWidget view={props.viewRef} map={props.mapRef} />
        <MeasurementWidget view={props.viewRef} map={props.mapRef} />
        <ElevationProfileWidget view={props.viewRef} map={props.mapRef} />
      </GHWidgetBar>
      <MapToast />
      <MapZoomCtrl view={props.viewRef} map={props.mapRef} layout={'horizontal'} />
      <NavigationToggle view={props.viewRef} map={props.mapRef} />
      <Search view={props.viewRef} map={props.mapRef} />
      <SketchWidget view={props.viewRef} map={props.mapRef} />
      <TwoDThreeDToggle view={props.viewRef} map={props.mapRef} />
    </div>
  )
}

WidgetPanel.propTypes = {
  mapRef: PropTypes.any,
  viewRef: PropTypes.any
}

export default connect(model => {
  const { mapMode, mapRef, mapViewRef, sceneViewRef } = model.map
  const viewRef = mapMode == MAP_MODES.TwoD ? mapViewRef : sceneViewRef
  return {
    mapRef,
    viewRef
  }
})(WidgetPanel)
